import React from 'react';
import { motion } from 'framer-motion';
import { useParallax } from '../hooks/useScrollAnimation';

const Hero: React.FC = () => {
  const parallaxOffset = useParallax(0.3);

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20"
    >
      {/* Background Image */}
      <div className="absolute inset-0 top-20 z-0">
        <motion.div 
          style={{ transform: `translateY(${parallaxOffset}px)` }}
          className="w-full h-full"
        >
          {/* Mobile Image */}
          <img 
            src="/pics/principal.jpg" 
            alt="Ale y Loren"
            className="w-full h-full object-fill md:hidden"
          />
          
          {/* Desktop Image */}
          <img 
            src="/pics/principal.jpg" 
            alt="Ale y Loren"
            className="hidden md:block w-full h-full object-fill"
          />
        </motion.div>
        
        {/* Overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/40 to-black/05"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-6xl mx-auto mb-32">
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
        >
          <motion.h1
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.5, delay: 0.5 }}
            className="font-wasted text-6xl md:text-8xl lg:text-9xl font-normal mb-6 text-white drop-shadow-2xl"
          >
            ¡Nos casamos!
          </motion.h1>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.8 }}
            className="mb-8"
          >
            <motion.h2 
              className="font-wasted text-3xl md:text-5xl lg:text-6xl font-medium mb-4 text-cream-100 drop-shadow-lg"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              Ale y Loren
            </motion.h2>
            
            <motion.p 
              className="font-wasted text-2xl md:text-3xl font-light text-cream-50 mb-2 drop-shadow-md"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.2, duration: 0.8 }}
            >
              17 / 10 / 2026
            </motion.p>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 3, duration: 1 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex items-center gap-2"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="text-white"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </motion.div>
        <p className="text-sm text-cream-50 font-medium drop-shadow-md">Desliza para continuar</p>
      </motion.div>
    </section>
  );
};

export default Hero; 
